import _ from 'lodash';

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetLatestOrderLineItemVersionByFormTypeID(formTypeId) {
  const response = await $.soap({
    body: {
      GetLatestOrderLineItemVersionByFormTypeID: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_line_item',
        FormTypeID: formTypeId
      }
    },
    blueprintArrays: ['GetLatestOrderLineItemVersionByFormTypeIDResponse'],
    blueprint: {
      lineItems: [
        '$..tuple',
        {
          id: '$..ID',
          formTypeId: '$..FormTypeID',
          imgUrl: '$..ImgUrl',
          csDataSheetId: '$..CSDataSheetID',
          clin: '$..CLIN',
          price: '$..Price',
          volumeBand: '$..VolumeBand',
          model: '$..Model',
          laserPrinterTonerCartridgeType: '$..LaserPrinterTonerCartridgeType',
          description: '$..Description',
          paperCapacityHandling: '$..PaperCapacityHandling',
          configurationAndPricing: '$..ConfigurationAndPricing',
          serviceAcronym: '$..ServiceAcronym',
          speedPPM: '$..SpeedPPM',
          isColor: '$..IsColor',
          isNIPR: '$..IsNIPR',
          monthlyVolume: '$..MonthlyVolume',
          estimatedMonthlyVolumeMono: '$..EstimatedMonthlyVolumeMono',
          estimatedMonthlyVolumeColor: '$..EstimatedMonthlyVolumeColor',
          deliveryTypeId: '$..DeliveryTypeID',
          chargesFrequencyId: '$..ChargesFrequencyID',
          panel: '$..Panel',
          compatibleDevice: '$..CompatibleDevice',
          warrantyYear: '$..WarrantyYear',
          dlaCost: '$..DLACost',
          version: '$..Version',
          versionStartDate: '$..VersionStartDate',
          isActive: '$..IsActive',
          isAdditionalAccessory: '$..IsAdditionalAccessory',
          isAdditionalService: '$..IsAdditionalService'
        }
      ]
    }
  });

  _.each(response.lineItems, (item) => {
    if (item.compatibleDevice && typeof item.compatibleDevice === 'string') {
      // For some reason it does not render correctly if you just set the cleaned string to compatibleDeviceKey
      item.compatibleDeviceKey = item.compatibleDevice.replace(/[\W_]+/g, '');
    }
  });

  cleanUpResponse(response);
  return response.lineItems;
}
